import { IYoutubeSearchResult } from 'motw_core/YouTube/IYoutubeSearchResult';
import * as React from 'react';
import { EGlyphicon } from "source/app/presentation/Shared/Glyphicon/EGlyphicon";
import MotwLogicServer from 'source/app/services/External/LogicServer/MotwLogicServer';
import IconWithText from 'source/app/services/Shared/IconWithText/IconWithText';
import * as toastr from 'toastr';
import { StyleClass } from 'source/app/presentation/Shared/Styles/CSS';

export function YoutubeDownloadLinkIcon({
	searchResult
}: {
	searchResult: IYoutubeSearchResult;
}) {
	return (
		<IconWithText
			iconSuffix={EGlyphicon.download}
			withClass={StyleClass(`youtubeDownloadLinkIcon`, {
				position: `relative`,
				top: `2px`,
				marginLeft: `15px`
			})}
			whenClicked={async () => {
				toastr.info(
					`Requested download from the url '${searchResult.link}'`
				);

				const response = await MotwLogicServer.PostYoutubeDownloadRequest(
					searchResult.link
				);

				if (response && response.result) {
					toastr.success(response.result);
				}
			}}
			displayAsBlock={false}
		>
			Download
		</IconWithText>
	);
}
